import Icon from 'veui/components/Icon'
import { IconUserCombined } from 'dls-icons-vue'

Icon.register('user-combined', IconUserCombined)
